import styled from 'styled-components'

export const HeaderWithButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  @media print {
    button {
      display: none;
    }
  }
  @media (min-width: 450px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    h3 {
      margin-bottom: 0;
    }
    button {
      display: block;
      margin-left: 15px;
    }
  }
`

export const SmallHeader = styled.h5`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  text-transform: uppercase;
  margin-top: 36px;
`

export const Heading = styled.h4`
  margin-top: 30px;
`
